import React, { useEffect, useState } from 'react';
import GlobalDialog from '../../../../components/mui/Dialogue/GlobalDialog';
import Box from '@mui/material/Box';
import GlobalWrapper from '../../../../components/Wrapper/GlobalWrapper';
import { Autocomplete, Button, Card, CardMedia, Chip, Stack, TextField, Typography } from '@mui/material';
import { CancelButton } from '../../../../components/mui/Buttons/Buttons';
import { Icon } from '@iconify/react';
import MotionContainer from '../../../../components/FramerMotion/MotionContainer';
import { compressImage } from '../../../../utils/constants/ImageCompress';
import Loader3D from '../../../../components/Loader/Loader3D';
import { useFormik, Form, FormikProvider } from 'formik';
import * as Yup from 'yup';
import GlobalSelectField from '../../../../components/mui/GlobalSelectField';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useSnackbar } from 'notistack';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { makePayment } from '../../../../redux/features/ogdSlice';
import { getCartItems } from '../../../../redux/features/cartSlice';
import useResponsive from '../../../../Hooks/useResponsive';
import CircularLoader from '../../../../components/Loader/CircularLoader';
import { pdfjs, Document, Page } from 'react-pdf';
// import pdfWorker from "pdfjs-dist/build/pdf.worker.min.mjs";
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';
import { CART_AED_TO_INR_VALUE } from '../../../../utils/constants/GlobalStaticData';

const PaymentMethodsPopup = ({ open, setOpen, isAvailabletotalPayingAmount, availableCartItems }) => {
  const [fileType, setFileType] = useState(false);
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };
  pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;
  const smUp = useResponsive('up', 'sm');

  const mdUp = useResponsive('up', 'md');
  const [compressesImg, setCompressesImg] = useState(null);
  const [loadingCart, setLoading] = useState(false);
  const [inrValue, setinrValue] = useState(CART_AED_TO_INR_VALUE);
  const [image, setImage] = useState(null);
  const [imageURL, setImageURL] = useState(null);
  const profile = JSON.parse(localStorage.getItem('cred')).profile;

  const { loading } = useSelector((state) => state.ogd);
  const { enqueueSnackbar } = useSnackbar();
  const location = useLocation();
  const dispatch = useDispatch();
  const Schema = Yup.object().shape({
    paymentMode: Yup.string().required('paymentMethod is required'),
    currencyType: Yup.string().required('currencyType is required'),
    // transactionDate: Yup.string().required("transactionDate is required"),
    transactionDate: Yup.date().nullable().required('Transaction date is required'),
    paymentAcc: Yup.string().required('payment account is required'),
    payingAmtAed: Yup.number().when('currencyType', {
      is: 'AED',
      then: (schema) => schema.required('Paying amount in AED is required'),
      otherwise: (schema) => schema.notRequired(),
    }),
  });
  const SchemaPaymentMethod = Yup.object().shape({
    paymentMode: Yup.string().required('paymentMethod is required'),
  });
  const formik = useFormik({
    initialValues: {
      leadId: location?.state.leadId,
      paymentProof: '',
      paymentMode: '',
      currencyType:
        availableCartItems[0].selectedCurrency === 1
          ? 'INR'
          : availableCartItems[0].selectedCurrency === 3
            ? 'AED to INR'
            : 'AED',
      paymentAcc: '',
      transactionDate: null,
      payingAmtAed: '',
      noLinkRemarks: '',
      remarks: '',
    },
    validationSchema: () => (formik.values?.paymentMode == 0 ? SchemaPaymentMethod : Schema),
    onSubmit: (values) => {
      if (!compressesImg && values?.paymentMode != 0) {
        enqueueSnackbar('Please upload payment screenshot..!', {
          variant: 'error',
        });
      } else if (
        values?.paymentMode != 0 &&
        values?.paymentMode != 3 &&
        !values.noLinkRemarks &&
        availableCartItems[0].selectedCurrency != 2
      ) {
        enqueueSnackbar('Kindly mention the reason for not choosing the payment link.', {
          variant: 'error',
        });
      } else {
        dispatch(makePayment(values)).then((res) => {
          if (res.payload.status === 'failed' || res.payload.status === 'error') {
            enqueueSnackbar(res.payload.message, { variant: 'error' });
          } else if (res.payload.status === 'success') {
            setOpen(false);
            dispatch(getCartItems(values.leadId));
            enqueueSnackbar(res.payload.message, {
              variant: 'success',
            });
          }
        });
      }
    },
  });
  useEffect(() => {
    if (inrValue) {
      formik.setFieldValue('payingAmtAed', CART_AED_TO_INR_VALUE * isAvailabletotalPayingAmount);
    }
  }, [open, inrValue]);

  useEffect(() => {
    if (compressesImg) {
      formik.setFieldValue('paymentProof', compressesImg);
    }
  }, [compressesImg]);

  useEffect(() => {
    if (compressesImg) {
      setLoading(false);
    }
  }, [compressesImg]);
  const paymentMethods = [
    { id: '0', name: 'Generate Link' },
    { id: '1', name: 'Cash In hand' },
    { id: '2', name: 'Bank Transfer' },
    { id: '3', name: 'Stripe' },
    { id: '4', name: 'EMI' },
  ];
  const filteredPaymentMethods =
    availableCartItems[0]?.selectedCurrency === 2
      ? paymentMethods.filter((method) => method.id !== '0')
      : paymentMethods;
  const handleImageChange = (e) => {
    setImage(null);
    setCompressesImg(null);
    setLoading(true);

    const file = e.target.files[0];
    if (file) {
      if (file.size > 2 * 1024 * 1024) {
        setLoading(false);
        enqueueSnackbar('File size should not exceed 2 MB', {
          variant: 'error',
        });
        return;
      }

      setImage(file);
    } else {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (image) {
      setFileType(true);
      const fileType = image.type;
      if (fileType === 'application/pdf') {
        const pdfUrl = URL.createObjectURL(image);
        setImageURL(pdfUrl);
        setCompressesImg(image);
      } else {
        compressImage(image, 0.5).then((compressedFile) => {
          const compressedUrl = compressedFile;
          const imageURL = URL.createObjectURL(compressedFile);
          setImageURL(imageURL);
          setCompressesImg(compressedUrl);
          setFileType(false);
        });
      }
    }
  }, [image]);

  useEffect(() => {
    if (!open) {
      setImage(null);
      formik.setFieldValue('paymentMode', '');
      setCompressesImg('');
    }
  }, [open]);
  return (
    <GlobalDialog
      title="Select Payment Method"
      open={open}
      setOpen={setOpen}
      fullWidth
      maxWidth={'sm'}
      closeButton={true}
      content={
        <>
          <FormikProvider value={formik}>
            <Form onSubmit={formik.handleSubmit}>
              {open ? (
                <GlobalWrapper>
                  <Box>
                    <MotionContainer delay={0.8}>
                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'center',
                          pb: 2,
                        }}
                      >
                        <Chip
                          size="small"
                          color="primary"
                          label={
                            <Box sx={{ display: 'flex' }}>
                              <Typography sx={{ fontWeight: 'bolder' }}>Paying amount :</Typography>
                              <Box pt={0.1}>
                                <Typography sx={{ fontWeight: 'bolder' }}>{isAvailabletotalPayingAmount}</Typography>
                              </Box>
                            </Box>
                          }
                          variant="outlined"
                        />
                      </Box>
                    </MotionContainer>

                    <MotionContainer delay={0.5}>
                      <Box>
                        <GlobalSelectField
                          options={{
                            name: 'paymentMode',
                            formik,
                            sx: { width: '100%' },
                            label: 'Payment Methods',
                            data: filteredPaymentMethods,
                            keys: {
                              id: 'id',
                              value: 'name',
                            },
                          }}
                        />
                      </Box>
                    </MotionContainer>
                    {formik.values.paymentMode == 0 ? null : (
                      <>
                        <Stack direction={'column'} spacing={2}>
                          <MotionContainer delay={0.5}>
                            <Box
                              sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                pt: 3,
                              }}
                            >
                              <Card
                                sx={{
                                  textAlign: 'center',
                                  padding: 2,
                                  width: '100%',
                                }}
                              >
                                <Typography variant="h6" gutterBottom>
                                  Upload Proof
                                </Typography>
                                {loadingCart ? (
                                  <Loader3D />
                                ) : (
                                  <>
                                    <input
                                      accept="image/jpeg, image/png, image/webp, application/pdf"
                                      style={{ display: 'none' }}
                                      id="upload-image"
                                      type="file"
                                      onChange={handleImageChange}
                                    />
                                    <label htmlFor="upload-image">
                                      <Button variant="contained" component="span">
                                        Choose File
                                      </Button>
                                    </label>
                                    {compressesImg && !fileType && (
                                      <CardMedia
                                        component="img"
                                        image={imageURL}
                                        alt="Uploaded image preview"
                                        sx={{
                                          marginTop: 2,
                                          width: '100%',
                                          objectFit: 'cover',
                                        }}
                                      />
                                    )}
                                    {fileType ? (
                                      <div style={{ textAlign: 'center' }}>
                                        <Document
                                          file={image}
                                          onLoadSuccess={onDocumentLoadSuccess}
                                          loading="Loading PDF..."
                                        >
                                          <Page pageNumber={pageNumber} />
                                        </Document>

                                        <p>
                                          Page {pageNumber} of {numPages}
                                        </p>
                                        <div>
                                          <button
                                            onClick={() => setPageNumber((prev) => Math.max(prev - 1, 1))}
                                            disabled={pageNumber === 1}
                                          >
                                            Previous
                                          </button>
                                          <button
                                            onClick={() => setPageNumber((prev) => Math.min(prev + 1, numPages))}
                                            disabled={pageNumber === numPages}
                                          >
                                            Next
                                          </button>
                                        </div>
                                      </div>
                                    ) : null}
                                  </>
                                )}
                              </Card>
                            </Box>
                          </MotionContainer>
                          <MotionContainer delay={0.6}>
                            <GlobalSelectField
                              options={{
                                name: 'currencyType',
                                formik,
                                sx: { width: '100%' },
                                label: 'Currency Type',

                                data: [
                                  { id: 'INR', value: 'INR' },
                                  { id: 'AED', value: 'AED' },
                                  { id: 'AED to INR', value: 'AED to INR' },
                                ],
                                keys: {
                                  id: 'id',
                                  value: 'value',
                                },
                              }}
                              disabled
                            />
                          </MotionContainer>
                          {formik.values.currencyType && formik.values.currencyType === 'AED' ? (
                            <>
                              <MotionContainer delay={1}>
                                <TextField
                                  name="payingAmtAed"
                                  label="Enter INR amount for 1 AED"
                                  type="number"
                                  disabled
                                  onChange={(e) => setinrValue(e.target.value)}
                                  value={inrValue}
                                  fullWidth
                                  onWheel={(e) => e.target.blur()}
                                  inputProps={{
                                    inputMode: 'decimal',
                                    pattern: '[0-9]*[.]?[0-9]+',
                                    onWheel: (e) => e.target.blur(),
                                  }}
                                />
                              </MotionContainer>
                              <MotionContainer delay={1}>
                                <TextField
                                  name="payingAmtAed"
                                  label="INR amount corresponding to AED"
                                  type="number"
                                  disabled
                                  onChange={formik.handleChange}
                                  value={formik.values.payingAmtAed}
                                  fullWidth
                                  onWheel={(e) => e.target.blur()}
                                  inputProps={{
                                    inputMode: 'numeric',
                                    pattern: '[0-9]*',
                                    onWheel: (e) => e.target.blur(),
                                  }}
                                  error={formik.touched.payingAmtAed && Boolean(formik.errors.payingAmtAed)}
                                  helperText={formik.touched.payingAmtAed && formik.errors.payingAmtAed}
                                />
                              </MotionContainer>
                            </>
                          ) : null}

                          <MotionContainer delay={0.7}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DatePicker
                                sx={{ width: '100%' }}
                                label="Transaction Date"
                                disableFuture
                                minDate={profile?.isReportingHead ? null : dayjs().subtract(2, 'day')}
                                value={formik.values.transactionDate}
                                onChange={(newValue) => {
                                  formik.setFieldValue('transactionDate', newValue);
                                }}
                                slotProps={{
                                  textField: {
                                    fullWidth: true,
                                    name: 'transactionDate',
                                    error: formik.touched.transactionDate && Boolean(formik.errors.transactionDate),
                                    helperText: formik.touched.transactionDate && formik.errors.transactionDate,
                                    onBlur: formik.handleBlur,
                                    readOnly: true,
                                  },
                                }}
                              />
                            </LocalizationProvider>
                          </MotionContainer>
                          <MotionContainer delay={0.6}>
                            <GlobalSelectField
                              options={{
                                name: 'paymentAcc',
                                formik,
                                sx: { width: '100%' },
                                label: 'Payment Account',
                                data: [
                                  { id: 1, value: 'Indian A/c' },
                                  { id: 2, value: 'GCC A/c' },
                                ],
                                keys: {
                                  id: 'id',
                                  value: 'value',
                                },
                              }}
                            />
                          </MotionContainer>

                          {/* ------------------------------------------------------------------- */}
                          {availableCartItems[0].selectedCurrency == 1 ||
                          (availableCartItems[0].selectedCurrency == 3 &&
                            formik.values.paymentMode != 0 &&
                            formik.values?.paymentMode != 3) ? (
                            <MotionContainer delay={1}>
                              <TextField
                                name="noLinkRemarks"
                                label="Reason for not choosing link payment"
                                onChange={formik.handleChange}
                                value={formik.values.noLinkRemarks}
                                fullWidth
                                multiline
                                rows={3}
                              />
                            </MotionContainer>
                          ) : null}

                          <MotionContainer delay={1}>
                            <TextField
                              name="remarks"
                              label="Remarks"
                              onChange={formik.handleChange}
                              value={formik.values.remarks}
                              fullWidth
                              multiline
                              rows={3}
                            />
                          </MotionContainer>
                        </Stack>
                      </>
                    )}

                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        padding: 2,
                      }}
                    >
                      <Stack direction={'row'} spacing={1}>
                        <CancelButton size="small" action={() => setOpen(false)}>
                          Cancel
                        </CancelButton>
                        {formik.values.paymentMode == 0 ? (
                          <Button
                            type="submit"
                            size={smUp ? 'medium' : 'small'}
                            sx={{
                              color: 'white',
                              background: `linear-gradient(to bottom, #0089d0 0%, #0089d0 10%, #a125c2 100%)`,
                              borderRadius: 3,
                            }}
                            disabled={loading ? true : false}
                          >
                            <Icon icon="mdi:cart-outline" height={22} width={22} />
                            {loading ? (
                              <Box sx={{ display: 'flex' }}>
                                Please Wait...!
                                <CircularLoader />
                              </Box>
                            ) : (
                              'Generate Link'
                            )}
                          </Button>
                        ) : (
                          <Button
                            type="submit"
                            size={smUp ? 'medium' : 'small'}
                            sx={{
                              color: 'white',
                              background: `linear-gradient(to bottom, #0089d0 0%, #0089d0 10%, #a125c2 100%)`,
                              borderRadius: 3,
                            }}
                            disabled={loading ? true : false}
                          >
                            <Icon icon="mdi:cart-outline" height={22} width={22} />
                            {loading ? (
                              <Box sx={{ display: 'flex' }}>
                                Please Wait...!
                                <CircularLoader />
                              </Box>
                            ) : (
                              'Make Payment'
                            )}
                          </Button>
                        )}
                      </Stack>
                    </Box>
                  </Box>
                </GlobalWrapper>
              ) : null}
            </Form>
          </FormikProvider>
        </>
      }
    />
  );
};

export default PaymentMethodsPopup;
